import { CTAButton } from 'components/atoms/Button/Button';
import React from 'react';
import './newsList.scss';
import { formatDate } from 'controls/utils';
import PropTypes from 'prop-types';
import { FallbackImage } from '@rcw/ui';

export function NewsList({ items, handleReadMore }) {

  return (
    <div className='card-list-container' id='news-articles'>
      <div className='card-grid'>
        {items.map((item) => (
          <div key={item.id} className='card'>
            <FallbackImage
              src={item.teaserImageUrl}
              alt={item.title}
              className='card-image'
            />
            <div className='card-content'>
              <p className='card-date proxima-nova-bold'>
                {formatDate(item.publishDate)}
              </p>
              <h3 className='card-title proxima-nova-bold'>
                {item.title}
              </h3>
              <p className='card-subtitle'>
                {item.summary}
              </p>

              <CTAButton
                ctaText='Read More'
                onClick={() => handleReadMore(item.aliasPath)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

NewsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  handleReadMore: PropTypes.func,
};
